export const permissionFragment = `
  fragment PermissionFragment on Permission {
    key
    title
  }
`;
